import { Container } from "./dependencyInjection/Container";
import { BasicAuthenticator } from "./instances/auth/authBasic";
import { AzureAuthenticator } from "./instances/auth/authMsalBrowser";
import { JwtDecode } from "./instances/decodeToken/jwtDecode";
import { HttpFetch } from "./instances/http/httpFetch";
import { SessionNextCookies } from "./instances/session/session-next-cookie";

const container = new Container();
// Register Instances
container.register("SessionManager", new SessionNextCookies());

container.register("NetworkClient", new HttpFetch());

container.register("AzureAuthenticator", new AzureAuthenticator());
container.register("BasicAuthenticator", new BasicAuthenticator());


container.register("JWTDecoder", new JwtDecode());

export default container;